import React from 'react';
import Header from '../components/Header';
import ToolsSection from '../components/ToolsSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const HerramientasPage = () => {
  const seoData = {
    title: 'Herramientas de Automatización',
    description: 'Descubre nuestras herramientas de automatización: ChatBot con IA, respuestas automáticas, botoneras, menús interactivos, horarios de atención y más.',
    keywords: 'herramientas automatización, ChatBot IA, respuestas automáticas, botoneras, menús interactivos, horarios atención, automatización atención cliente',
    canonical: '/herramientas',
    ogTitle: 'Herramientas de Automatización - Runamatic',
    ogDescription: 'Herramientas avanzadas de automatización para transformar tu atención al cliente. ChatBot con IA, respuestas automáticas y más.',
    schema: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Herramientas de Automatización Runamatic",
      "description": "Suite completa de herramientas para automatización de atención al cliente",
      "brand": {
        "@type": "Brand",
        "name": "Runamatic"
      },
      "category": "Software de Automatización",
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "USD",
        "price": "40",
        "priceValidUntil": "2040-12-31",
        "url": "https://runamatic.io/planes",
        "seller": {
          "@type": "Organization",
          "name": "Runamatic"
        },
        "description": "Acceso completo a todas las herramientas de automatización desde $40 USD/mes"
      }
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <ToolsSection />
      </main>
      <Footer />
    </>
  );
};

export default HerramientasPage; 